import { KeyboardArrowLeft } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface IBackButton {
    backurl: string;
}

export const BackButton: React.FC<IBackButton> = ({
    backurl
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Button
            variant="text"
            startIcon={<KeyboardArrowLeft style={{color:'#22638D', fontSize: '24px'}} />}
            onClick={() => {
                navigate(backurl);
            }}
        >
            <Typography
                textTransform="none"
                color="#22638D"
            >
                {t("AdminConsole.Back")}
            </Typography>
        </Button>
    )
}